// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={246}
    height={138}
    viewBox="0 0 246 138"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2725_153142)">
      <rect
        width={246}
        height={138}
        fill="#C8FBE7"
      />
      <g clipPath="url(#clip1_2725_153142)">
        <rect
          x={47.6475}
          y={23.295}
          width={158.232}
          height={142.829}
          rx={3.3654}
          fill="#FAFBFF"
        />
        <rect
          x={88.8375}
          y={26.9866}
          width={109.705}
          height={7.62145}
          rx={3.81073}
          fill="white"
        />
        <rect
          opacity={0.4}
          x={91.1992}
          y={29.0223}
          width={9.39509}
          height={3.64585}
          rx={1.82293}
          fill="#ABE3FF"
        />
        <rect
          x={88.8375}
          y={26.9866}
          width={109.705}
          height={7.62145}
          rx={3.81073}
          stroke="#E6E8F0"
          strokeWidth={0.0909318}
        />
        <rect
          opacity={0.4}
          x={55.2783}
          y={45.1697}
          width={54.2671}
          height={5.46878}
          rx={2.73439}
          fill="#ABE3FF"
        />
        <rect
          x={55.2783}
          y={51.7603}
          width={35.1965}
          height={2.2436}
          rx={1.1218}
          fill="#ABE3FF"
          fillOpacity={0.2}
        />
        <rect
          opacity={0.4}
          x={178.958}
          y={45.1698}
          width={9.67554}
          height={2.94473}
          rx={1.47236}
          fill="#ABE3FF"
        />
        <rect
          opacity={0.4}
          x={193.739}
          y={45.1698}
          width={4.90788}
          height={2.94473}
          rx={1.47236}
          fill="#ABE3FF"
        />
        <rect
          x={152.779}
          y={52.9279}
          width={15.0522}
          height={4.48889}
          rx={2.24445}
          fill="white"
        />
        <path
          d="M144.626 59.3285H142.561V55.6726H141.842V59.9736H144.626V59.3285ZM146.293 56.7663C145.666 56.7663 145.131 57.055 144.941 57.6941L145.512 57.9214C145.623 57.5835 145.887 57.3746 146.268 57.3746C146.692 57.3746 146.999 57.5835 146.999 58.075V58.4007C146.815 58.204 146.514 58.0934 146.127 58.0934C145.389 58.0934 144.855 58.4621 144.855 59.0704C144.855 59.6848 145.377 60.0412 146.084 60.0412C146.514 60.0412 146.846 59.9122 147.036 59.6664V59.9736H147.675V58.0074C147.675 57.1472 147.018 56.7663 146.293 56.7663ZM146.287 59.5312C145.869 59.5312 145.555 59.3715 145.555 59.0643C145.555 58.7509 145.869 58.5911 146.287 58.5911C146.711 58.5911 147.012 58.757 147.012 59.0643C147.012 59.3653 146.711 59.5312 146.287 59.5312ZM149.508 60.0412C150.288 60.0412 150.798 59.648 150.798 59.095C150.798 58.6219 150.478 58.3208 149.821 58.1549L149.508 58.0812C149.133 57.989 148.875 57.903 148.875 57.6695C148.875 57.4729 149.096 57.3377 149.434 57.3377C149.809 57.3377 150.116 57.4974 150.19 57.9214L150.761 57.7801C150.675 57.1288 150.128 56.7724 149.434 56.7724C148.697 56.7724 148.217 57.1411 148.217 57.6818C148.217 58.1549 148.512 58.4621 149.219 58.6342L149.526 58.714C149.95 58.8123 150.14 58.9107 150.14 59.1196C150.14 59.3346 149.895 59.4821 149.501 59.4821C149.096 59.4821 148.752 59.2793 148.654 58.8369L148.101 59.0151C148.273 59.734 148.85 60.0412 149.508 60.0412ZM151.533 58.9537C151.533 59.5681 151.877 59.9736 152.522 59.9736H152.928V59.3838H152.596C152.332 59.3838 152.209 59.2179 152.209 58.9107V57.393H152.928V56.8338H152.209V55.8016L151.533 56.1948V56.8338H150.949V57.393H151.533V58.9537ZM157.283 56.2317V55.6726H154.604V56.2993H156.398L155.292 57.4483V57.9828H155.784C156.343 57.9828 156.724 58.2225 156.724 58.6956C156.724 59.1564 156.349 59.3961 155.894 59.3961C155.477 59.3961 155.108 59.1933 154.887 58.7448L154.334 59.0827C154.629 59.7524 155.212 60.0412 155.876 60.0412C156.791 60.0412 157.455 59.5128 157.455 58.6772C157.455 57.9828 156.982 57.4913 156.146 57.4053L157.283 56.2317ZM159.549 55.605C158.59 55.605 157.896 56.3546 157.896 57.8292C157.896 59.2916 158.59 60.0412 159.549 60.0412C160.507 60.0412 161.201 59.2916 161.201 57.8292C161.201 56.3546 160.507 55.605 159.549 55.605ZM159.549 56.244C160.145 56.244 160.47 56.7601 160.47 57.8231C160.47 58.8861 160.145 59.4022 159.549 59.4022C158.946 59.4022 158.621 58.8861 158.621 57.8231C158.621 56.7601 158.946 56.244 159.549 56.244ZM164.694 59.9736C165.978 59.9736 166.851 59.1319 166.851 57.8231C166.851 56.5143 165.978 55.6726 164.694 55.6726H163.048V59.9736H164.694ZM164.657 56.3177C165.61 56.3177 166.101 56.9014 166.101 57.8231C166.101 58.7448 165.61 59.3285 164.657 59.3285H163.766V56.3177H164.657ZM168.638 56.7663C168.011 56.7663 167.477 57.055 167.286 57.6941L167.858 57.9214C167.968 57.5835 168.233 57.3746 168.614 57.3746C169.038 57.3746 169.345 57.5835 169.345 58.075V58.4007C169.16 58.204 168.859 58.0934 168.472 58.0934C167.735 58.0934 167.2 58.4621 167.2 59.0704C167.2 59.6848 167.723 60.0412 168.429 60.0412C168.859 60.0412 169.191 59.9122 169.382 59.6664V59.9736H170.021V58.0074C170.021 57.1472 169.363 56.7663 168.638 56.7663ZM168.632 59.5312C168.214 59.5312 167.901 59.3715 167.901 59.0643C167.901 58.7509 168.214 58.5911 168.632 58.5911C169.056 58.5911 169.357 58.757 169.357 59.0643C169.357 59.3653 169.056 59.5312 168.632 59.5312ZM171.415 60.9997L173.363 56.8338H172.613L171.771 58.6464L170.96 56.8338H170.186L171.421 59.3961L170.671 60.9997H171.415ZM174.775 60.0412C175.556 60.0412 176.066 59.648 176.066 59.095C176.066 58.6219 175.746 58.3208 175.089 58.1549L174.775 58.0812C174.4 57.989 174.142 57.903 174.142 57.6695C174.142 57.4729 174.364 57.3377 174.701 57.3377C175.076 57.3377 175.384 57.4974 175.457 57.9214L176.029 57.7801C175.943 57.1288 175.396 56.7724 174.701 56.7724C173.964 56.7724 173.485 57.1411 173.485 57.6818C173.485 58.1549 173.78 58.4621 174.486 58.6342L174.794 58.714C175.218 58.8123 175.408 58.9107 175.408 59.1196C175.408 59.3346 175.162 59.4821 174.769 59.4821C174.364 59.4821 174.019 59.2793 173.921 58.8369L173.368 59.0151C173.54 59.734 174.118 60.0412 174.775 60.0412Z"
          fill="white"
        />
        <g clipPath="url(#clip2_2725_153142)">
          <path
            d="M164.922 55.0359L165.377 55.4906L165.831 55.0359"
            stroke="white"
            strokeWidth={0.136398}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <rect
          x={152.779}
          y={52.9279}
          width={15.0522}
          height={4.48889}
          rx={2.24445}
          stroke="#E6E8F0"
          strokeWidth={0.0909318}
        />
        <rect
          x={168.773}
          y={52.9279}
          width={14.7858}
          height={4.48889}
          rx={2.24445}
          fill="white"
        />
        <path
          d="M159.905 59.9736C161.189 59.9736 162.062 59.1319 162.062 57.8231C162.062 56.5143 161.189 55.6726 159.905 55.6726H158.258V59.9736H159.905ZM159.868 56.3177C160.82 56.3177 161.312 56.9014 161.312 57.8231C161.312 58.7448 160.82 59.3285 159.868 59.3285H158.977V56.3177H159.868ZM165.422 58.3822C165.422 57.4176 164.813 56.7663 163.959 56.7663C163.075 56.7663 162.442 57.4176 162.442 58.4007C162.442 59.3838 163.081 60.0412 163.978 60.0412C164.598 60.0412 165.151 59.7463 165.416 59.0397L164.838 58.8185C164.66 59.2793 164.359 59.4514 163.965 59.4514C163.511 59.4514 163.179 59.1626 163.13 58.5543H165.416C165.422 58.499 165.422 58.4375 165.422 58.3822ZM163.953 57.3315C164.346 57.3315 164.635 57.565 164.721 58.0689H163.154C163.24 57.5835 163.529 57.3315 163.953 57.3315ZM169.286 56.7724C168.899 56.7724 168.549 56.9322 168.358 57.3193C168.18 56.9752 167.848 56.7724 167.437 56.7724C167.099 56.7724 166.791 56.9137 166.607 57.2578V56.8338H165.925V59.9736H166.607V58.0812C166.607 57.6265 166.877 57.3684 167.252 57.3684C167.578 57.3684 167.811 57.6203 167.811 58.0566V59.9736H168.493V58.0812C168.493 57.6265 168.764 57.3684 169.139 57.3684C169.464 57.3684 169.698 57.6203 169.698 58.0566V59.9736H170.38V57.9275C170.38 57.2271 169.919 56.7724 169.286 56.7724ZM172.452 60.0412C173.373 60.0412 174.055 59.3715 174.055 58.4007C174.055 57.436 173.373 56.7663 172.452 56.7663C171.53 56.7663 170.848 57.436 170.848 58.4007C170.848 59.3715 171.53 60.0412 172.452 60.0412ZM172.452 59.4329C171.929 59.4329 171.549 59.052 171.549 58.4007C171.549 57.7555 171.929 57.3807 172.452 57.3807C172.974 57.3807 173.361 57.7555 173.361 58.4007C173.361 59.052 172.974 59.4329 172.452 59.4329ZM178.764 58.7755L176.491 55.6726H175.839V59.9736H176.552V56.8707L178.825 59.9736H179.483V55.6726H178.764V58.7755ZM181.46 56.7663C180.833 56.7663 180.299 57.055 180.108 57.6941L180.68 57.9214C180.79 57.5835 181.054 57.3746 181.435 57.3746C181.859 57.3746 182.166 57.5835 182.166 58.075V58.4007C181.982 58.204 181.681 58.0934 181.294 58.0934C180.557 58.0934 180.022 58.4621 180.022 59.0704C180.022 59.6848 180.544 60.0412 181.251 60.0412C181.681 60.0412 182.013 59.9122 182.203 59.6664V59.9736H182.842V58.0074C182.842 57.1472 182.185 56.7663 181.46 56.7663ZM181.454 59.5312C181.036 59.5312 180.723 59.3715 180.723 59.0643C180.723 58.7509 181.036 58.5911 181.454 58.5911C181.878 58.5911 182.179 58.757 182.179 59.0643C182.179 59.3653 181.878 59.5312 181.454 59.5312ZM186.819 56.7724C186.432 56.7724 186.082 56.9322 185.891 57.3193C185.713 56.9752 185.381 56.7724 184.97 56.7724C184.632 56.7724 184.325 56.9137 184.14 57.2578V56.8338H183.458V59.9736H184.14V58.0812C184.14 57.6265 184.411 57.3684 184.785 57.3684C185.111 57.3684 185.345 57.6203 185.345 58.0566V59.9736H186.027V58.0812C186.027 57.6265 186.297 57.3684 186.672 57.3684C186.997 57.3684 187.231 57.6203 187.231 58.0566V59.9736H187.913V57.9275C187.913 57.2271 187.452 56.7724 186.819 56.7724ZM191.367 58.3822C191.367 57.4176 190.759 56.7663 189.905 56.7663C189.02 56.7663 188.387 57.4176 188.387 58.4007C188.387 59.3838 189.026 60.0412 189.923 60.0412C190.544 60.0412 191.097 59.7463 191.361 59.0397L190.784 58.8185C190.605 59.2793 190.304 59.4514 189.911 59.4514C189.456 59.4514 189.125 59.1626 189.076 58.5543H191.361C191.367 58.499 191.367 58.4375 191.367 58.3822ZM189.899 57.3315C190.292 57.3315 190.581 57.565 190.667 58.0689H189.1C189.186 57.5835 189.475 57.3315 189.899 57.3315Z"
          fill="white"
        />
        <g clipPath="url(#clip3_2725_153142)">
          <path
            d="M180.649 55.0359L181.104 55.4906L181.559 55.0359"
            stroke="white"
            strokeWidth={0.136398}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <rect
          x={168.773}
          y={52.9279}
          width={14.7858}
          height={4.48889}
          rx={2.24445}
          stroke="#E6E8F0"
          strokeWidth={0.0909318}
        />
        <rect
          x={184.501}
          y={52.9279}
          width={13.9866}
          height={4.48889}
          rx={2.24445}
          fill="white"
        />
        <path
          d="M175.882 59.9736H176.552L177.578 56.8707L178.598 59.9736H179.267L180.539 55.6726H179.814L178.923 58.8431L177.897 55.6726H177.258L176.238 58.8492L175.353 55.6726H174.61L175.882 59.9736ZM182.079 60.0412C183.001 60.0412 183.683 59.3715 183.683 58.4007C183.683 57.436 183.001 56.7663 182.079 56.7663C181.158 56.7663 180.476 57.436 180.476 58.4007C180.476 59.3715 181.158 60.0412 182.079 60.0412ZM182.079 59.4329C181.557 59.4329 181.176 59.052 181.176 58.4007C181.176 57.7555 181.557 57.3807 182.079 57.3807C182.602 57.3807 182.989 57.7555 182.989 58.4007C182.989 59.052 182.602 59.4329 182.079 59.4329ZM185.693 56.7663C185.336 56.7663 185.041 56.9444 184.863 57.3254V56.8338H184.181V59.9736H184.863V58.3085C184.863 57.8047 185.146 57.4913 185.545 57.4913H185.865V56.7663H185.693ZM187.426 60.0412C188.206 60.0412 188.716 59.648 188.716 59.095C188.716 58.6219 188.397 58.3208 187.739 58.1549L187.426 58.0812C187.051 57.989 186.793 57.903 186.793 57.6695C186.793 57.4729 187.014 57.3377 187.352 57.3377C187.727 57.3377 188.034 57.4974 188.108 57.9214L188.679 57.7801C188.593 57.1288 188.047 56.7724 187.352 56.7724C186.615 56.7724 186.136 57.1411 186.136 57.6818C186.136 58.1549 186.431 58.4621 187.137 58.6342L187.444 58.714C187.868 58.8123 188.059 58.9107 188.059 59.1196C188.059 59.3346 187.813 59.4821 187.42 59.4821C187.014 59.4821 186.67 59.2793 186.572 58.8369L186.019 59.0151C186.191 59.734 186.768 60.0412 187.426 60.0412ZM189.216 59.9736H189.904V58.4007L191.163 59.9736H191.999L190.623 58.3146L191.962 56.8338H191.126L189.904 58.2471V55.6726H189.216V59.9736ZM193.966 56.7663C193.468 56.7663 193.143 57.012 192.94 57.35V56.8338H192.258V60.9997H192.94V59.4575C193.143 59.7954 193.474 60.0412 193.966 60.0412C194.777 60.0412 195.391 59.353 195.391 58.4007C195.391 57.4544 194.777 56.7663 193.966 56.7663ZM193.812 59.4329C193.296 59.4329 192.927 59.0581 192.927 58.4068C192.927 57.7555 193.296 57.3807 193.812 57.3807C194.335 57.3807 194.697 57.7555 194.697 58.4068C194.697 59.0581 194.335 59.4329 193.812 59.4329ZM197.166 56.7663C196.539 56.7663 196.005 57.055 195.814 57.6941L196.386 57.9214C196.496 57.5835 196.76 57.3746 197.141 57.3746C197.565 57.3746 197.872 57.5835 197.872 58.075V58.4007C197.688 58.204 197.387 58.0934 197 58.0934C196.263 58.0934 195.728 58.4621 195.728 59.0704C195.728 59.6848 196.25 60.0412 196.957 60.0412C197.387 60.0412 197.719 59.9122 197.909 59.6664V59.9736H198.548V58.0074C198.548 57.1472 197.891 56.7663 197.166 56.7663ZM197.16 59.5312C196.742 59.5312 196.429 59.3715 196.429 59.0643C196.429 58.7509 196.742 58.5911 197.16 58.5911C197.584 58.5911 197.885 58.757 197.885 59.0643C197.885 59.3653 197.584 59.5312 197.16 59.5312ZM200.577 60.0412C201.241 60.0412 201.825 59.7156 202.058 58.9414L201.45 58.7202C201.284 59.2363 200.995 59.4329 200.577 59.4329C200.123 59.4329 199.723 59.0827 199.723 58.4007C199.723 57.7248 200.123 57.3746 200.577 57.3746C200.995 57.3746 201.284 57.5712 201.45 58.0873L202.058 57.8661C201.825 57.0919 201.241 56.7663 200.577 56.7663C199.699 56.7663 199.029 57.4299 199.029 58.4007C199.029 59.3776 199.699 60.0412 200.577 60.0412ZM205.321 58.3822C205.321 57.4176 204.713 56.7663 203.859 56.7663C202.974 56.7663 202.341 57.4176 202.341 58.4007C202.341 59.3838 202.98 60.0412 203.877 60.0412C204.498 60.0412 205.051 59.7463 205.315 59.0397L204.738 58.8185C204.559 59.2793 204.258 59.4514 203.865 59.4514C203.41 59.4514 203.079 59.1626 203.029 58.5543H205.315C205.321 58.499 205.321 58.4375 205.321 58.3822ZM203.853 57.3315C204.246 57.3315 204.535 57.565 204.621 58.0689H203.054C203.14 57.5835 203.429 57.3315 203.853 57.3315Z"
          fill="white"
        />
        <g clipPath="url(#clip4_2725_153142)">
          <path
            d="M195.578 55.0359L196.033 55.4906L196.487 55.0359"
            stroke="white"
            strokeWidth={0.136398}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <rect
          x={184.501}
          y={52.9279}
          width={13.9866}
          height={4.48889}
          rx={2.24445}
          stroke="#E6E8F0"
          strokeWidth={0.0909318}
        />
        <rect
          x={55.2783}
          y={67.1101}
          width={51.4903}
          height={24.1115}
          rx={2.13936}
          fill="#ABE3FF"
          fillOpacity={0.2}
        />
        <g filter="url(#filter0_d_2725_153142)">
          <rect
            x={58.1309}
            y={69.9626}
            width={26.1059}
            height={18.2131}
            rx={1.26893}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x={60.8828}
            y={72.715}
            width={19.0706}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={60.8828}
            y={76.3347}
            width={7.01126}
            height={5.46878}
            rx={2.73439}
            fill="#ABE3FF"
          />
          <path
            d="M69.7207 79.0906H81.1491"
            stroke="#DDF4FF"
            strokeWidth={0.344047}
            strokeLinecap="round"
          />
          <rect
            x={60.8828}
            y={83.1797}
            width={10.5169}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
        </g>
        <g filter="url(#filter1_d_2725_153142)">
          <rect
            x={86.1973}
            y={69.9626}
            width={17.476}
            height={8.26393}
            rx={1.26893}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x={87.5732}
            y={70.6508}
            width={14.7236}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={87.5293}
            y={73.2004}
            width={9.39509}
            height={3.64585}
            rx={1.82293}
            fill="#ABE3FF"
          />
        </g>
        <g filter="url(#filter2_d_2725_153142)">
          <rect
            x={86.1973}
            y={80.0722}
            width={17.476}
            height={8.26393}
            rx={1.26893}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x={87.5732}
            y={80.7603}
            width={14.7236}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={87.5293}
            y={83.31}
            width={9.39509}
            height={3.64585}
            rx={1.82293}
            fill="#ABE3FF"
          />
        </g>
        <rect
          x={110.835}
          y={67.1101}
          width={51.4903}
          height={24.1115}
          rx={2.13936}
          fill="#ABE3FF"
          fillOpacity={0.2}
        />
        <g filter="url(#filter3_d_2725_153142)">
          <rect
            x={113.688}
            y={69.9626}
            width={26.1059}
            height={18.2131}
            rx={1.26893}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x={116.439}
            y={72.715}
            width={19.0706}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={116.439}
            y={76.3347}
            width={7.01126}
            height={5.46878}
            rx={2.73439}
            fill="#ABE3FF"
          />
          <path
            d="M125.276 79.0906H136.705"
            stroke="#DDF4FF"
            strokeWidth={0.344047}
            strokeLinecap="round"
          />
          <rect
            x={116.439}
            y={83.1797}
            width={10.5169}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
        </g>
        <g filter="url(#filter4_d_2725_153142)">
          <rect
            x={141.755}
            y={69.9626}
            width={17.476}
            height={8.26393}
            rx={1.26893}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x={143.131}
            y={70.6508}
            width={14.7236}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={143.087}
            y={73.2004}
            width={9.39509}
            height={3.64585}
            rx={1.82293}
            fill="#ABE3FF"
          />
        </g>
        <g filter="url(#filter5_d_2725_153142)">
          <rect
            x={141.755}
            y={80.0722}
            width={17.476}
            height={8.26393}
            rx={1.26893}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x={143.131}
            y={80.7603}
            width={14.7236}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={143.087}
            y={83.31}
            width={9.39509}
            height={3.64585}
            rx={1.82293}
            fill="#ABE3FF"
          />
        </g>
        <rect
          x={166.392}
          y={67.1101}
          width={31.8108}
          height={23.9181}
          rx={2.13936}
          fill="#ABE3FF"
          fillOpacity={0.2}
        />
        <g filter="url(#filter6_d_2725_153142)">
          <rect
            x={169.244}
            y={69.9626}
            width={26.1059}
            height={18.2131}
            rx={1.26893}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x={171.996}
            y={72.715}
            width={19.0706}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={171.996}
            y={76.3348}
            width={7.01126}
            height={5.46878}
            rx={2.73439}
            fill="#ABE3FF"
          />
          <rect
            x={171.996}
            y={83.1797}
            width={10.5169}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
        </g>
        <rect
          x={55.2783}
          y={101.024}
          width={48.3223}
          height={31.4724}
          rx={2.13936}
          fill="#ABE3FF"
          fillOpacity={0.2}
        />
        <g filter="url(#filter7_d_2725_153142)">
          <rect
            x={58.1309}
            y={103.876}
            width={42.6173}
            height={25.7674}
            rx={1.31508}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            opacity={0.4}
            x={60.9834}
            y={106.729}
            width={19.0706}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
          />
          <g opacity={0.4}>
            <rect
              x={60.9834}
              y={111.297}
              width={3.4878}
              height={3.4878}
              rx={1.7439}
              fill="#ABE3FF"
            />
          </g>
          <rect
            x={65.9248}
            y={112.27}
            width={31.9713}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <g opacity={0.4}>
            <rect
              x={60.9834}
              y={115.948}
              width={3.4878}
              height={3.4878}
              rx={1.7439}
              fill="#ABE3FF"
            />
          </g>
          <rect
            x={65.9248}
            y={116.92}
            width={23.2774}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <g opacity={0.4}>
            <rect
              x={60.9834}
              y={120.598}
              width={3.4878}
              height={3.4878}
              rx={1.7439}
              fill="#ABE3FF"
            />
          </g>
          <rect
            x={65.9248}
            y={121.571}
            width={31.9713}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={60.9834}
            y={125.249}
            width={6.02968}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
          />
        </g>
        <rect
          x={107.96}
          y={101.024}
          width={41.8719}
          height={31.4724}
          rx={2.13936}
          fill="#ABE3FF"
          fillOpacity={0.2}
        />
        <g filter="url(#filter8_d_2725_153142)">
          <rect
            x={110.812}
            y={103.876}
            width={36.167}
            height={25.7674}
            rx={1.31508}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            opacity={0.4}
            x={113.665}
            y={106.729}
            width={19.0706}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
          />
          <g opacity={0.4}>
            <rect
              x={113.665}
              y={111.297}
              width={3.4878}
              height={3.4878}
              rx={1.7439}
              fill="#ABE3FF"
            />
          </g>
          <rect
            x={118.606}
            y={112.27}
            width={25.521}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <g opacity={0.4}>
            <rect
              x={113.665}
              y={115.948}
              width={3.4878}
              height={3.4878}
              rx={1.7439}
              fill="#ABE3FF"
            />
          </g>
          <rect
            x={118.606}
            y={116.92}
            width={20.0522}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <g opacity={0.4}>
            <rect
              x={113.665}
              y={120.598}
              width={3.4878}
              height={3.4878}
              rx={1.7439}
              fill="#ABE3FF"
            />
          </g>
          <rect
            x={118.606}
            y={121.571}
            width={23.4176}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={113.665}
            y={125.249}
            width={6.02968}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
          />
        </g>
        <rect
          x={154.192}
          y={101.024}
          width={44.3628}
          height={31.0466}
          rx={2.13936}
          fill="#ABE3FF"
          fillOpacity={0.2}
        />
        <g filter="url(#filter9_d_2725_153142)">
          <rect
            x={157.045}
            y={103.876}
            width={38.6579}
            height={25.3416}
            rx={1.31508}
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            opacity={0.4}
            x={159.897}
            y={106.729}
            width={28.1853}
            height={2.2436}
            rx={1.1218}
            fill="#ABE3FF"
          />
          <rect
            x={159.897}
            y={111.297}
            width={32.9529}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            x={159.897}
            y={114.002}
            width={23.4176}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            x={159.897}
            y={116.707}
            width={31.9713}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            x={159.897}
            y={119.413}
            width={28.1853}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            x={159.897}
            y={122.118}
            width={25.521}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
            fillOpacity={0.2}
          />
          <rect
            opacity={0.4}
            x={159.897}
            y={124.823}
            width={6.02968}
            height={1.54248}
            rx={0.771238}
            fill="#ABE3FF"
          />
        </g>
        <rect
          opacity={0.4}
          x={54.7168}
          y={28.2028}
          width={26.5026}
          height={5.46878}
          rx={2.73439}
          fill="#ABE3FF"
        />
      </g>
      <rect
        x={47.7807}
        y={23.4282}
        width={157.966}
        height={142.563}
        rx={3.23221}
        stroke="#4B4A51"
        strokeWidth={0.266385}
      />
      <g filter="url(#filter10_d_2725_153142)">
        <rect
          x={58.9414}
          y={78}
          width={77.2202}
          height={42}
          rx={3.85176}
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M69.8911 91.7351C71.4116 91.7351 72.4789 90.6678 72.4789 89.0961C72.4789 87.5243 71.4116 86.457 69.8911 86.457C68.3705 86.457 67.2959 87.5243 67.2959 89.0961C67.2959 90.6678 68.3705 91.7351 69.8911 91.7351ZM69.8911 90.9456C68.9042 90.9456 68.1878 90.2511 68.1878 89.0961C68.1878 87.941 68.9042 87.2465 69.8911 87.2465C70.8707 87.2465 71.5871 87.941 71.5871 89.0961C71.5871 90.2511 70.8707 90.9456 69.8911 90.9456Z"
          fill="#37363F"
        />
        <path
          d="M75.4425 87.8387C74.8504 87.8387 74.4629 88.1311 74.2217 88.5332V87.9191H73.4102V92.8755H74.2217V91.0406C74.4629 91.4427 74.8577 91.7351 75.4425 91.7351C76.4075 91.7351 77.1385 90.9163 77.1385 89.7832C77.1385 88.6574 76.4075 87.8387 75.4425 87.8387ZM75.2597 91.0114C74.6457 91.0114 74.2071 90.5654 74.2071 89.7905C74.2071 89.0156 74.6457 88.5697 75.2597 88.5697C75.8811 88.5697 76.3124 89.0156 76.3124 89.7905C76.3124 90.5654 75.8811 91.0114 75.2597 91.0114Z"
          fill="#37363F"
        />
        <path
          d="M80.0897 87.8387C79.4976 87.8387 79.1101 88.1311 78.8689 88.5332V87.9191H78.0575V92.8755H78.8689V91.0406C79.1101 91.4427 79.5049 91.7351 80.0897 91.7351C81.0547 91.7351 81.7857 90.9163 81.7857 89.7832C81.7857 88.6574 81.0547 87.8387 80.0897 87.8387ZM79.907 91.0114C79.2929 91.0114 78.8543 90.5654 78.8543 89.7905C78.8543 89.0156 79.2929 88.5697 79.907 88.5697C80.5284 88.5697 80.9597 89.0156 80.9597 89.7905C80.9597 90.5654 80.5284 91.0114 79.907 91.0114Z"
          fill="#37363F"
        />
        <path
          d="M84.4446 91.7351C85.5411 91.7351 86.3526 90.9383 86.3526 89.7832C86.3526 88.6355 85.5411 87.8387 84.4446 87.8387C83.348 87.8387 82.5365 88.6355 82.5365 89.7832C82.5365 90.9383 83.348 91.7351 84.4446 91.7351ZM84.4446 91.0114C83.8232 91.0114 83.3699 90.5581 83.3699 89.7832C83.3699 89.0156 83.8232 88.5697 84.4446 88.5697C85.0659 88.5697 85.5265 89.0156 85.5265 89.7832C85.5265 90.5581 85.0659 91.0114 84.4446 91.0114Z"
          fill="#37363F"
        />
        <path
          d="M89.0646 87.8387C88.6406 87.8387 88.2897 88.0507 88.0777 88.5039V87.9191H87.2662V91.6547H88.0777V89.6736C88.0777 89.0741 88.414 88.7013 88.8891 88.7013H89.2693V87.8387H89.0646Z"
          fill="#37363F"
        />
        <path
          d="M90.4592 90.4412C90.4592 91.1722 90.8686 91.6547 91.6362 91.6547H92.1187V90.9529H91.7239C91.4096 90.9529 91.2634 90.7555 91.2634 90.39V88.5843H92.1187V87.9191H91.2634V86.691L90.4592 87.1588V87.9191H89.7647V88.5843H90.4592V90.4412Z"
          fill="#37363F"
        />
        <path
          d="M94.5419 91.7351C95.4703 91.7351 96.1574 91.1576 96.1574 90.1488V87.9191H95.346V90.0976C95.346 90.7117 95.0097 91.0041 94.5419 91.0041C94.074 91.0041 93.7304 90.7117 93.7304 90.0976V87.9191H92.9189V90.1488C92.9189 91.1576 93.6134 91.7351 94.5419 91.7351Z"
          fill="#37363F"
        />
        <path
          d="M99.089 87.8387C98.6504 87.8387 98.2483 88.0141 98.0144 88.4454V87.9191H97.2029V91.6547H98.0144V89.447C98.0144 88.8914 98.3726 88.5551 98.877 88.5551C99.3156 88.5551 99.63 88.8768 99.63 89.4104V91.6547H100.441V89.2788C100.441 88.4089 99.8712 87.8387 99.089 87.8387Z"
          fill="#37363F"
        />
        <path
          d="M101.903 87.3708C102.202 87.3708 102.436 87.1807 102.436 86.8664C102.436 86.5521 102.202 86.3547 101.903 86.3547C101.596 86.3547 101.362 86.5521 101.362 86.8664C101.362 87.1807 101.596 87.3708 101.903 87.3708ZM101.486 91.6547H102.298V87.9191H101.486V91.6547Z"
          fill="#37363F"
        />
        <path
          d="M103.772 90.4412C103.772 91.1722 104.182 91.6547 104.949 91.6547H105.432V90.9529H105.037C104.723 90.9529 104.577 90.7555 104.577 90.39V88.5843H105.432V87.9191H104.577V86.691L103.772 87.1588V87.9191H103.078V88.5843H103.772V90.4412Z"
          fill="#37363F"
        />
        <path
          d="M106.685 87.3708C106.985 87.3708 107.219 87.1807 107.219 86.8664C107.219 86.5521 106.985 86.3547 106.685 86.3547C106.378 86.3547 106.144 86.5521 106.144 86.8664C106.144 87.1807 106.378 87.3708 106.685 87.3708ZM106.269 91.6547H107.08V87.9191H106.269V91.6547Z"
          fill="#37363F"
        />
        <path
          d="M111.545 89.7613C111.545 88.6136 110.821 87.8387 109.805 87.8387C108.752 87.8387 107.999 88.6136 107.999 89.7832C107.999 90.9529 108.76 91.7351 109.827 91.7351C110.565 91.7351 111.223 91.3842 111.538 90.5435L110.85 90.2803C110.638 90.8286 110.28 91.0333 109.812 91.0333C109.271 91.0333 108.877 90.6897 108.818 89.966H111.538C111.545 89.9002 111.545 89.8271 111.545 89.7613ZM109.798 88.5112C110.266 88.5112 110.609 88.789 110.712 89.3885H108.847C108.95 88.811 109.293 88.5112 109.798 88.5112Z"
          fill="#37363F"
        />
        <path
          d="M113.912 91.7351C114.841 91.7351 115.447 91.2672 115.447 90.6093C115.447 90.0464 115.067 89.6882 114.285 89.4908L113.912 89.4031C113.466 89.2934 113.159 89.1911 113.159 88.9133C113.159 88.6794 113.422 88.5185 113.825 88.5185C114.27 88.5185 114.636 88.7086 114.724 89.213L115.404 89.0449C115.301 88.27 114.651 87.846 113.825 87.846C112.947 87.846 112.377 88.2846 112.377 88.9279C112.377 89.4908 112.728 89.8563 113.569 90.061L113.934 90.1561C114.439 90.273 114.665 90.39 114.665 90.6385C114.665 90.8944 114.373 91.0699 113.905 91.0699C113.422 91.0699 113.013 90.8286 112.896 90.3023L112.238 90.5143C112.443 91.3696 113.13 91.7351 113.912 91.7351Z"
          fill="#37363F"
        />
        <path
          d="M74.7483 106.316V99.1979H72.7097L67.2959 106.149V108.288H72.5427V110.895H74.7483V108.288H76.2521V106.316H74.7483ZM72.5427 102.49V106.316H69.5517L72.5427 102.49Z"
          fill="#37363F"
        />
        <path
          d="M82.3015 103.359C81.583 103.359 80.9814 103.559 80.4801 103.943L80.9313 101.17H85.6433V99.1979H79.2436L78.1074 106.166H79.8953C80.3465 105.514 80.9814 105.263 81.6498 105.263C82.8696 105.263 83.6215 106.032 83.6215 107.185C83.6215 108.305 82.8529 109.073 81.583 109.073C80.5136 109.073 79.7783 108.488 79.0933 107.319L77.3555 108.472C78.3079 110.226 79.6781 111.095 81.5997 111.095C83.9056 111.095 85.9274 109.658 85.9274 107.085C85.9274 105.314 84.7243 103.359 82.3015 103.359Z"
          fill="#37363F"
        />
        <rect
          x={58.9414}
          y={78}
          width={77.2202}
          height={42}
          rx={3.85176}
          stroke="#29292F"
          strokeWidth={0.350072}
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter11_d_2725_153142)">
        <rect
          x={17.6475}
          y={14.4706}
          width={76.4865}
          height={51.2118}
          rx={3.85176}
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M28.1439 28.2057C29.3647 28.2057 30.125 27.6136 30.125 26.7071C30.125 25.9761 29.6206 25.4863 28.5752 25.2158L27.9831 25.055C27.4129 24.9015 27.0839 24.7333 27.0839 24.3239C27.0839 23.9365 27.4713 23.6879 28.0781 23.6879C28.6922 23.6879 29.1673 23.9804 29.3062 24.631L30.0738 24.4336C29.8911 23.4467 29.1089 22.9277 28.0708 22.9277C26.9596 22.9277 26.2066 23.5271 26.2066 24.3824C26.2066 25.1135 26.6745 25.5886 27.6175 25.8445L28.2024 26.0053C28.9407 26.2027 29.2551 26.4001 29.2551 26.7729C29.2551 27.1823 28.8238 27.4455 28.1439 27.4455C27.4129 27.4455 26.9304 27.0288 26.7695 26.3708L26.002 26.6121C26.2505 27.6867 27.0473 28.2057 28.1439 28.2057Z"
          fill="#37363F"
        />
        <path
          d="M32.5607 24.3093C31.8151 24.3093 31.1791 24.6529 30.9524 25.4132L31.6323 25.6837C31.7639 25.2816 32.0782 25.033 32.5315 25.033C33.0359 25.033 33.4014 25.2816 33.4014 25.8664V26.2539C33.1821 26.0199 32.8239 25.8884 32.3633 25.8884C31.4861 25.8884 30.8501 26.327 30.8501 27.0507C30.8501 27.7817 31.4715 28.2057 32.3122 28.2057C32.8239 28.2057 33.2187 28.0522 33.4453 27.7598V28.1253H34.2056V25.786C34.2056 24.7626 33.4234 24.3093 32.5607 24.3093ZM32.5534 27.599C32.0563 27.599 31.6835 27.4089 31.6835 27.0434C31.6835 26.6706 32.0563 26.4805 32.5534 26.4805C33.0578 26.4805 33.416 26.6779 33.416 27.0434C33.416 27.4016 33.0578 27.599 32.5534 27.599Z"
          fill="#37363F"
        />
        <path
          d="M37.1453 24.3093C36.7067 24.3093 36.3046 24.4848 36.0707 24.9161V24.3897H35.2592V28.1253H36.0707V25.9176C36.0707 25.362 36.4289 25.0257 36.9333 25.0257C37.3719 25.0257 37.6863 25.3474 37.6863 25.881V28.1253H38.4977V25.7495C38.4977 24.8795 37.9275 24.3093 37.1453 24.3093Z"
          fill="#37363F"
        />
        <path
          d="M42.2984 25.0038C42.0571 24.6017 41.6624 24.3093 41.0775 24.3093C40.1053 24.3093 39.3815 25.1281 39.3815 26.2539C39.3815 27.387 40.1053 28.2057 41.0775 28.2057C41.6624 28.2057 42.0571 27.9133 42.2984 27.5113V28.1253H43.1025V23.0081H42.2984V25.0038ZM41.2603 27.482C40.6389 27.482 40.2003 27.0288 40.2003 26.2539C40.2003 25.4863 40.6389 25.0404 41.2603 25.0404C41.8744 25.0404 42.313 25.4863 42.313 26.2539C42.313 27.0288 41.8744 27.482 41.2603 27.482Z"
          fill="#37363F"
        />
        <path
          d="M46.2219 24.3093C45.6371 24.3093 45.2423 24.6017 45.0011 25.0038V23.0081H44.1896V28.1253H45.0011V27.5113C45.2423 27.9133 45.6297 28.2057 46.2219 28.2057C47.1869 28.2057 47.9179 27.387 47.9179 26.2539C47.9179 25.1281 47.1869 24.3093 46.2219 24.3093ZM46.0391 27.482C45.4251 27.482 44.9864 27.0288 44.9864 26.2539C44.9864 25.4863 45.4251 25.0404 46.0391 25.0404C46.6605 25.0404 47.0918 25.4863 47.0918 26.2539C47.0918 27.0288 46.6605 27.482 46.0391 27.482Z"
          fill="#37363F"
        />
        <path
          d="M50.5767 28.2057C51.6733 28.2057 52.4847 27.4089 52.4847 26.2539C52.4847 25.1062 51.6733 24.3093 50.5767 24.3093C49.4801 24.3093 48.6687 25.1062 48.6687 26.2539C48.6687 27.4089 49.4801 28.2057 50.5767 28.2057ZM50.5767 27.482C49.9553 27.482 49.5021 27.0288 49.5021 26.2539C49.5021 25.4863 49.9553 25.0404 50.5767 25.0404C51.1981 25.0404 51.6586 25.4863 51.6586 26.2539C51.6586 27.0288 51.1981 27.482 50.5767 27.482Z"
          fill="#37363F"
        />
        <path
          d="M55.5531 24.3897L54.6539 25.5886L53.7621 24.3897H52.7971L54.1715 26.2319L52.7459 28.1253H53.689L54.6393 26.8606L55.5824 28.1253H56.5473L55.1218 26.2173L56.4962 24.3897H55.5531Z"
          fill="#37363F"
        />
        <path
          d="M58.451 23.0081L60.3956 28.1253H61.2216L63.1662 23.0081H62.2816L60.8196 26.9849L59.3575 23.0081H58.451Z"
          fill="#37363F"
        />
        <path
          d="M64.3086 23.8415C64.6084 23.8415 64.8423 23.6514 64.8423 23.337C64.8423 23.0227 64.6084 22.8253 64.3086 22.8253C64.0016 22.8253 63.7677 23.0227 63.7677 23.337C63.7677 23.6514 64.0016 23.8415 64.3086 23.8415ZM63.8919 28.1253H64.7034V24.3897H63.8919V28.1253Z"
          fill="#37363F"
        />
        <path
          d="M67.231 28.2057C68.1594 28.2057 68.7661 27.7379 68.7661 27.0799C68.7661 26.5171 68.386 26.1588 67.6038 25.9615L67.231 25.8737C66.785 25.7641 66.478 25.6617 66.478 25.3839C66.478 25.15 66.7412 24.9892 67.1432 24.9892C67.5892 24.9892 67.9547 25.1793 68.0424 25.6837L68.7223 25.5155C68.6199 24.7406 67.9693 24.3166 67.1432 24.3166C66.266 24.3166 65.6958 24.7553 65.6958 25.3986C65.6958 25.9615 66.0467 26.327 66.8874 26.5317L67.2529 26.6267C67.7573 26.7437 67.9839 26.8606 67.9839 27.1092C67.9839 27.3651 67.6915 27.5405 67.2236 27.5405C66.7412 27.5405 66.3318 27.2993 66.2148 26.7729L65.5569 26.9849C65.7616 27.8402 66.4487 28.2057 67.231 28.2057Z"
          fill="#37363F"
        />
        <path
          d="M70.0978 23.8415C70.3975 23.8415 70.6315 23.6514 70.6315 23.337C70.6315 23.0227 70.3975 22.8253 70.0978 22.8253C69.7908 22.8253 69.5569 23.0227 69.5569 23.337C69.5569 23.6514 69.7908 23.8415 70.0978 23.8415ZM69.6811 28.1253H70.4926V24.3897H69.6811V28.1253Z"
          fill="#37363F"
        />
        <path
          d="M71.9675 26.9118C71.9675 27.6428 72.3768 28.1253 73.1444 28.1253H73.6269V27.4235H73.2322C72.9178 27.4235 72.7716 27.2262 72.7716 26.8606V25.055H73.6269V24.3897H72.7716V23.1616L71.9675 23.6295V24.3897H71.273V25.055H71.9675V26.9118Z"
          fill="#37363F"
        />
        <path
          d="M75.8898 28.2057C76.8182 28.2057 77.4249 27.7379 77.4249 27.0799C77.4249 26.5171 77.0448 26.1588 76.2626 25.9615L75.8898 25.8737C75.4438 25.7641 75.1368 25.6617 75.1368 25.3839C75.1368 25.15 75.4 24.9892 75.802 24.9892C76.248 24.9892 76.6135 25.1793 76.7012 25.6837L77.3811 25.5155C77.2787 24.7406 76.6281 24.3166 75.802 24.3166C74.9248 24.3166 74.3546 24.7553 74.3546 25.3986C74.3546 25.9615 74.7055 26.327 75.5462 26.5317L75.9117 26.6267C76.4161 26.7437 76.6427 26.8606 76.6427 27.1092C76.6427 27.3651 76.3503 27.5405 75.8825 27.5405C75.4 27.5405 74.9906 27.2993 74.8736 26.7729L74.2157 26.9849C74.4204 27.8402 75.1076 28.2057 75.8898 28.2057Z"
          fill="#37363F"
        />
        <path
          d="M34.223 36.433V34.6284H26.7372V36.6001H31.4659L28.7423 39.4073V41.0783H30.0456C31.4492 41.0783 32.4017 41.6297 32.4017 42.7993C32.4017 43.9021 31.5328 44.5037 30.3798 44.5037C29.277 44.5037 28.3413 43.9523 27.723 42.7492L26.002 43.8353C26.8541 45.7903 28.5585 46.5255 30.3464 46.5255C32.9196 46.5255 34.7243 45.1052 34.7243 42.7492C34.7243 40.8945 33.5379 39.6078 31.3991 39.2904L34.223 36.433Z"
          fill="#37363F"
        />
        <path
          d="M42.1178 41.2286C42.9198 40.3765 43.8723 39.3405 43.8723 37.8366C43.8723 35.9151 42.4854 34.4279 39.9456 34.4279C37.3222 34.4279 36.2695 36.2325 35.9687 37.8199L37.8903 38.4382C38.1075 37.4857 38.6088 36.4498 39.9456 36.4498C40.898 36.4498 41.5497 37.0847 41.5497 37.9369C41.5497 38.7389 41.1319 39.2904 40.4803 39.9754L36.2194 44.6039V46.325H43.9057V44.3533H39.1936L42.1178 41.2286Z"
          fill="#37363F"
        />
        <path
          d="M48.083 45.274C50.2605 41.144 55.4653 30.1405 58.8646 40.0523C63.1137 52.4421 65.0836 34.2714 72.1859 41.6003C77.8677 47.4634 83.2008 41.9026 85.1571 37.606"
          stroke="#0078EF"
          strokeWidth={1.04434}
          strokeLinecap="round"
        />
        <path
          d="M27.0405 54.6509V53.9319H26.6881V54.6509H26.002V54.9987H26.6881V55.7177H27.0405V54.9987H27.7408V54.6509H27.0405Z"
          fill="#37363F"
        />
        <path
          d="M28.5144 52.8463V53.2223H28.9279V56.136H29.3321V52.8463H28.5144Z"
          fill="#37363F"
        />
        <path
          d="M31.0919 54.0964C30.965 54.0964 30.8522 54.1199 30.7629 54.1528L31.7592 52.8463H31.261L30.1473 54.3643C29.9499 54.6274 29.8747 54.8718 29.8747 55.1303C29.8747 55.7271 30.354 56.1783 31.012 56.1783C31.6699 56.1783 32.154 55.7224 32.154 55.1256C32.154 54.5381 31.6887 54.0964 31.0919 54.0964ZM31.012 55.7929C30.5937 55.7929 30.2976 55.5203 30.2976 55.1303C30.2976 54.7496 30.5937 54.4676 31.012 54.4676C31.4255 54.4676 31.7216 54.7496 31.7216 55.1303C31.7216 55.5156 31.4302 55.7929 31.012 55.7929Z"
          fill="#37363F"
        />
        <path
          d="M33.0976 54.2938C33.5252 54.2938 33.8448 53.9789 33.8448 53.5465C33.8448 53.1236 33.5252 52.7993 33.0976 52.7993C32.6699 52.7993 32.3503 53.1236 32.3503 53.5465C32.3503 53.9789 32.6699 54.2938 33.0976 54.2938ZM33.0976 56.136L35.2546 52.8463H34.8693L32.7075 56.136H33.0976ZM33.0976 53.9883C32.8579 53.9883 32.684 53.8003 32.684 53.5465C32.684 53.2975 32.8579 53.1142 33.0976 53.1142C33.3372 53.1142 33.5205 53.2975 33.5205 53.5465C33.5205 53.8003 33.3372 53.9883 33.0976 53.9883ZM34.8599 56.183C35.2922 56.183 35.6118 55.8634 35.6118 55.4357C35.6118 55.0081 35.2922 54.6885 34.8599 54.6885C34.4369 54.6885 34.1174 55.0081 34.1174 55.4357C34.1174 55.8634 34.4369 56.183 34.8599 56.183ZM34.8599 55.8728C34.6249 55.8728 34.4463 55.6895 34.4463 55.4357C34.4463 55.1867 34.6249 54.9987 34.8599 54.9987C35.1043 54.9987 35.2828 55.1867 35.2828 55.4357C35.2828 55.6895 35.1043 55.8728 34.8599 55.8728Z"
          fill="#37363F"
        />
        <path
          d="M39.631 53.7204C39.335 53.7204 39.053 53.852 38.912 54.1716C38.7804 53.8896 38.5172 53.7204 38.193 53.7204C37.9345 53.7204 37.6901 53.8332 37.5397 54.1058V53.7627H37.1356V56.136H37.5397V54.6932C37.5397 54.3079 37.7747 54.0823 38.099 54.0823C38.3951 54.0823 38.5971 54.3032 38.5971 54.6885V56.136H39.0013V54.6932C39.0013 54.3079 39.2316 54.0823 39.5605 54.0823C39.8519 54.0823 40.0587 54.3032 40.0587 54.6885V56.136H40.4628V54.618C40.4628 54.0776 40.1151 53.7204 39.631 53.7204Z"
          fill="#37363F"
        />
        <path
          d="M42.1334 56.183C42.8195 56.183 43.3271 55.6801 43.3271 54.947C43.3271 54.2186 42.8195 53.7204 42.1334 53.7204C41.452 53.7204 40.9397 54.2186 40.9397 54.947C40.9397 55.6801 41.452 56.183 42.1334 56.183ZM42.1334 55.8164C41.687 55.8164 41.3533 55.4921 41.3533 54.947C41.3533 54.4112 41.687 54.087 42.1334 54.087C42.5846 54.087 42.9182 54.4112 42.9182 54.947C42.9182 55.4921 42.5846 55.8164 42.1334 55.8164Z"
          fill="#37363F"
        />
        <path
          d="M44.8935 53.7204C44.6021 53.7204 44.3672 53.8755 44.2309 54.1716V53.7627H43.8267V56.136H44.2309V54.8624C44.2309 54.43 44.4705 54.1481 44.8089 54.1481H45.0345V53.7204H44.8935Z"
          fill="#37363F"
        />
        <path
          d="M47.4168 54.9235C47.4168 54.1998 46.9562 53.7204 46.3312 53.7204C45.6733 53.7204 45.1939 54.1998 45.1939 54.947C45.1939 55.6848 45.6733 56.183 46.3312 56.183C46.7729 56.183 47.1912 55.9856 47.4074 55.4451L47.0643 55.3042C46.9139 55.6848 46.6508 55.8211 46.3359 55.8211C45.9411 55.8211 45.6404 55.5532 45.6075 55.0363H47.4121C47.4168 55.0034 47.4168 54.9658 47.4168 54.9235ZM46.3265 54.0682C46.6696 54.0682 46.9327 54.2844 46.9938 54.7261H45.6216C45.6874 54.3032 45.9505 54.0682 46.3265 54.0682Z"
          fill="#37363F"
        />
        <path
          d="M49.1258 55.4357C49.1258 55.8446 49.3514 56.136 49.8072 56.136H50.0892V55.7788H49.8448C49.6239 55.7788 49.5299 55.6425 49.5299 55.4028V54.1058H50.0892V53.7627H49.5299V52.9826L49.1258 53.2458V53.7627H48.684V54.1058H49.1258V55.4357Z"
          fill="#37363F"
        />
        <path
          d="M51.6455 53.7204C51.3636 53.7204 51.0816 53.8426 50.9218 54.1293V52.8463H50.5177V56.136H50.9218V54.7261C50.9218 54.3314 51.1897 54.0823 51.5609 54.0823C51.8993 54.0823 52.1296 54.3267 52.1296 54.712V56.136H52.5337V54.6509C52.5337 54.0823 52.1625 53.7204 51.6455 53.7204Z"
          fill="#37363F"
        />
        <path
          d="M54.043 53.7204C53.5731 53.7204 53.1783 53.9554 53.0608 54.4159L53.4039 54.5428C53.4791 54.2609 53.7141 54.0823 54.0383 54.0823C54.372 54.0823 54.6681 54.2468 54.6681 54.6932V54.9846C54.5224 54.8154 54.278 54.7214 53.949 54.7214C53.4274 54.7214 52.9903 54.9846 52.9903 55.4498C52.9903 55.9245 53.4227 56.183 53.9349 56.183C54.2827 56.183 54.5318 56.0843 54.6775 55.901V56.136H55.0722V54.6509C55.0722 53.993 54.5694 53.7204 54.043 53.7204ZM54.0477 55.8634C53.6859 55.8634 53.4039 55.7271 53.4039 55.4498C53.4039 55.1726 53.6859 55.0363 54.0477 55.0363C54.4049 55.0363 54.6775 55.182 54.6775 55.4498C54.6775 55.7177 54.4049 55.8634 54.0477 55.8634Z"
          fill="#37363F"
        />
        <path
          d="M56.7855 53.7204C56.5035 53.7204 56.2215 53.8426 56.0617 54.1293V53.7627H55.6576V56.136H56.0617V54.7261C56.0617 54.3314 56.3296 54.0823 56.7009 54.0823C57.0392 54.0823 57.2695 54.3267 57.2695 54.712V56.136H57.6737V54.6509C57.6737 54.0823 57.3024 53.7204 56.7855 53.7204Z"
          fill="#37363F"
        />
        <path
          d="M60.0011 55.7788C59.8085 55.7788 59.7333 55.6707 59.7333 55.478V52.8463H59.3291V55.5015C59.3291 55.8728 59.5359 56.136 59.9447 56.136H60.1985V55.7788H60.0011Z"
          fill="#37363F"
        />
        <path
          d="M61.482 53.7204C61.0121 53.7204 60.6173 53.9554 60.4998 54.4159L60.8429 54.5428C60.9181 54.2609 61.1531 54.0823 61.4773 54.0823C61.811 54.0823 62.1071 54.2468 62.1071 54.6932V54.9846C61.9614 54.8154 61.717 54.7214 61.388 54.7214C60.8664 54.7214 60.4293 54.9846 60.4293 55.4498C60.4293 55.9245 60.8617 56.183 61.3739 56.183C61.7217 56.183 61.9708 56.0843 62.1165 55.901V56.136H62.5112V54.6509C62.5112 53.993 62.0084 53.7204 61.482 53.7204ZM61.4867 55.8634C61.1249 55.8634 60.8429 55.7271 60.8429 55.4498C60.8429 55.1726 61.1249 55.0363 61.4867 55.0363C61.8439 55.0363 62.1165 55.182 62.1165 55.4498C62.1165 55.7177 61.8439 55.8634 61.4867 55.8634Z"
          fill="#37363F"
        />
        <path
          d="M63.9707 56.183C64.544 56.183 64.92 55.8916 64.92 55.4921C64.92 55.1397 64.6897 54.9282 64.1916 54.8013L63.9519 54.7402C63.6699 54.6697 63.4349 54.5851 63.4349 54.3737C63.4349 54.1951 63.6323 54.0729 63.9096 54.0729C64.2104 54.0729 64.4735 54.1998 64.5393 54.5569L64.8871 54.477C64.8166 53.9695 64.3936 53.7204 63.9096 53.7204C63.3832 53.7204 63.0308 53.993 63.0308 54.3784C63.0308 54.7167 63.2423 54.9517 63.7545 55.0833L63.9942 55.1397C64.3466 55.229 64.5158 55.3136 64.5158 55.5015C64.5158 55.6942 64.3044 55.8305 63.966 55.8305C63.6511 55.8305 63.3644 55.6848 63.2799 55.323L62.9368 55.4216C63.0778 55.9715 63.4866 56.183 63.9707 56.183Z"
          fill="#37363F"
        />
        <path
          d="M65.5688 55.4357C65.5688 55.8446 65.7944 56.136 66.2502 56.136H66.5322V55.7788H66.2878C66.0669 55.7788 65.9729 55.6425 65.9729 55.4028V54.1058H66.5322V53.7627H65.9729V52.9826L65.5688 53.2458V53.7627H65.127V54.1058H65.5688V55.4357Z"
          fill="#37363F"
        />
        <path
          d="M69.2451 53.7204C68.8503 53.7204 68.5778 53.9272 68.418 54.2186V53.7627H68.0138V56.9114H68.418V55.6801C68.5778 55.9715 68.8503 56.1783 69.2451 56.1783C69.8701 56.1783 70.3448 55.6801 70.3448 54.947C70.3448 54.2186 69.8701 53.7204 69.2451 53.7204ZM69.1746 55.8117C68.7281 55.8117 68.4086 55.4921 68.4086 54.9517C68.4086 54.4112 68.7281 54.087 69.1746 54.087C69.621 54.087 69.9359 54.4112 69.9359 54.9517C69.9359 55.4921 69.621 55.8117 69.1746 55.8117Z"
          fill="#37363F"
        />
        <path
          d="M72.9577 54.9235C72.9577 54.1998 72.4972 53.7204 71.8722 53.7204C71.2142 53.7204 70.7349 54.1998 70.7349 54.947C70.7349 55.6848 71.2142 56.183 71.8722 56.183C72.3139 56.183 72.7322 55.9856 72.9483 55.4451L72.6053 55.3042C72.4549 55.6848 72.1917 55.8211 71.8769 55.8211C71.4821 55.8211 71.1813 55.5532 71.1484 55.0363H72.953C72.9577 55.0034 72.9577 54.9658 72.9577 54.9235ZM71.8675 54.0682C72.2105 54.0682 72.4737 54.2844 72.5348 54.7261H71.1625C71.2283 54.3032 71.4915 54.0682 71.8675 54.0682Z"
          fill="#37363F"
        />
        <path
          d="M74.528 53.7204C74.2366 53.7204 74.0017 53.8755 73.8654 54.1716V53.7627H73.4612V56.136H73.8654V54.8624C73.8654 54.43 74.1051 54.1481 74.4434 54.1481H74.669V53.7204H74.528Z"
          fill="#37363F"
        />
        <path
          d="M75.2764 53.3069C75.4409 53.3069 75.5677 53.1941 75.5677 53.0249C75.5677 52.8651 75.4409 52.7476 75.2764 52.7476C75.1166 52.7476 74.9944 52.8651 74.9944 53.0249C74.9944 53.1941 75.1166 53.3069 75.2764 53.3069ZM75.0743 56.136H75.4784V53.7627H75.0743V56.136Z"
          fill="#37363F"
        />
        <path
          d="M77.1762 56.183C77.8624 56.183 78.3699 55.6801 78.3699 54.947C78.3699 54.2186 77.8624 53.7204 77.1762 53.7204C76.4948 53.7204 75.9825 54.2186 75.9825 54.947C75.9825 55.6801 76.4948 56.183 77.1762 56.183ZM77.1762 55.8164C76.7298 55.8164 76.3961 55.4921 76.3961 54.947C76.3961 54.4112 76.7298 54.087 77.1762 54.087C77.6274 54.087 77.961 54.4112 77.961 54.947C77.961 55.4921 77.6274 55.8164 77.1762 55.8164Z"
          fill="#37363F"
        />
        <path
          d="M80.6835 54.2139C80.5238 53.9225 80.2512 53.7204 79.8564 53.7204C79.2361 53.7204 78.7567 54.2186 78.7567 54.947C78.7567 55.6801 79.2361 56.1783 79.8564 56.1783C80.2512 56.1783 80.5238 55.9762 80.6835 55.6895V56.136H81.0877V52.8463H80.6835V54.2139ZM79.9316 55.8117C79.4852 55.8117 79.1656 55.4921 79.1656 54.947C79.1656 54.4065 79.4852 54.087 79.9316 54.087C80.3781 54.087 80.6929 54.4065 80.6929 54.947C80.6929 55.4921 80.3781 55.8117 79.9316 55.8117Z"
          fill="#37363F"
        />
        <rect
          x={17.6475}
          y={14.4706}
          width={76.4865}
          height={51.2118}
          rx={3.85176}
          stroke="#29292F"
          strokeWidth={0.350072}
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter12_d_2725_153142)">
        <rect
          x={150.706}
          y={35.2941}
          width={72.9475}
          height={51.2118}
          rx={3.85176}
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M162.372 48.1812H159.916V43.8316H159.061V48.9488H162.372V48.1812Z"
          fill="#37363F"
        />
        <path
          d="M163.58 44.6649C163.88 44.6649 164.114 44.4749 164.114 44.1605C164.114 43.8462 163.88 43.6488 163.58 43.6488C163.273 43.6488 163.039 43.8462 163.039 44.1605C163.039 44.4749 163.273 44.6649 163.58 44.6649ZM163.163 48.9488H163.975V45.2132H163.163V48.9488Z"
          fill="#37363F"
        />
        <path
          d="M164.704 45.2132L166.195 48.9488H166.956L168.432 45.2132H167.57L166.583 47.8596L165.589 45.2132H164.704Z"
          fill="#37363F"
        />
        <path
          d="M172.373 47.0554C172.373 45.9077 171.649 45.1328 170.633 45.1328C169.58 45.1328 168.827 45.9077 168.827 47.0774C168.827 48.247 169.588 49.0292 170.655 49.0292C171.393 49.0292 172.051 48.6783 172.366 47.8376L171.678 47.5745C171.466 48.1227 171.108 48.3274 170.64 48.3274C170.099 48.3274 169.705 47.9838 169.646 47.2601H172.366C172.373 47.1943 172.373 47.1212 172.373 47.0554ZM170.626 45.8054C171.094 45.8054 171.437 46.0832 171.54 46.6826H169.675C169.778 46.1051 170.121 45.8054 170.626 45.8054Z"
          fill="#37363F"
        />
        <path
          d="M177.103 48.9488C178.63 48.9488 179.669 47.9473 179.669 46.3902C179.669 44.8331 178.63 43.8316 177.103 43.8316H175.143V48.9488H177.103ZM177.059 44.5992C178.192 44.5992 178.777 45.2936 178.777 46.3902C178.777 47.4867 178.192 48.1812 177.059 48.1812H175.999V44.5992H177.059Z"
          fill="#37363F"
        />
        <path
          d="M183.987 47.0554C183.987 45.9077 183.264 45.1328 182.247 45.1328C181.195 45.1328 180.442 45.9077 180.442 47.0774C180.442 48.247 181.202 49.0292 182.269 49.0292C183.008 49.0292 183.666 48.6783 183.98 47.8376L183.293 47.5745C183.081 48.1227 182.723 48.3274 182.255 48.3274C181.714 48.3274 181.319 47.9838 181.261 47.2601H183.98C183.987 47.1943 183.987 47.1212 183.987 47.0554ZM182.24 45.8054C182.708 45.8054 183.052 46.0832 183.154 46.6826H181.29C181.392 46.1051 181.736 45.8054 182.24 45.8054Z"
          fill="#37363F"
        />
        <path
          d="M188.906 45.1401C188.445 45.1401 188.029 45.3302 187.802 45.7907C187.59 45.3814 187.195 45.1401 186.705 45.1401C186.303 45.1401 185.938 45.3083 185.719 45.7176V45.2132H184.907V48.9488H185.719V46.6972C185.719 46.1563 186.04 45.8492 186.486 45.8492C186.874 45.8492 187.151 46.1489 187.151 46.668V48.9488H187.963V46.6972C187.963 46.1563 188.285 45.8492 188.73 45.8492C189.118 45.8492 189.396 46.1489 189.396 46.668V48.9488H190.207V46.5145C190.207 45.6811 189.659 45.1401 188.906 45.1401Z"
          fill="#37363F"
        />
        <path
          d="M192.993 49.0292C194.09 49.0292 194.901 48.2324 194.901 47.0774C194.901 45.9296 194.09 45.1328 192.993 45.1328C191.897 45.1328 191.085 45.9296 191.085 47.0774C191.085 48.2324 191.897 49.0292 192.993 49.0292ZM192.993 48.3055C192.372 48.3055 191.919 47.8523 191.919 47.0774C191.919 46.3098 192.372 45.8638 192.993 45.8638C193.615 45.8638 194.075 46.3098 194.075 47.0774C194.075 47.8523 193.615 48.3055 192.993 48.3055Z"
          fill="#37363F"
        />
        <path
          d="M197.262 49.0292C198.191 49.0292 198.798 48.5614 198.798 47.9034C198.798 47.3405 198.418 46.9823 197.635 46.7849L197.262 46.6972C196.817 46.5876 196.51 46.4852 196.51 46.2074C196.51 45.9735 196.773 45.8127 197.175 45.8127C197.621 45.8127 197.986 46.0027 198.074 46.5072L198.754 46.339C198.651 45.5641 198.001 45.1401 197.175 45.1401C196.298 45.1401 195.727 45.5787 195.727 46.2221C195.727 46.7849 196.078 47.1505 196.919 47.3552L197.284 47.4502C197.789 47.5672 198.015 47.6841 198.015 47.9327C198.015 48.1885 197.723 48.364 197.255 48.364C196.773 48.364 196.363 48.1227 196.246 47.5964L195.588 47.8084C195.793 48.6637 196.48 49.0292 197.262 49.0292Z"
          fill="#37363F"
        />
        <path
          d="M159.061 55.4519V57.4236H160.648V67.1485H162.837V55.4519H159.061Z"
          fill="#37363F"
        />
        <path
          d="M171.95 62.5701V55.4519H169.912L164.498 62.403V64.5418H169.745V67.1485H171.95V64.5418H173.454V62.5701H171.95ZM169.745 58.7437V62.5701H166.754L169.745 58.7437Z"
          fill="#37363F"
        />
        <path
          d="M177.632 66.0962C179.809 61.9663 185.014 56.1844 188.413 66.0962C192.663 78.486 194.632 51.4384 201.735 58.7673C207.416 64.6304 212.75 57.5031 214.706 53.2066"
          stroke="#0078EF"
          strokeWidth={1.04434}
          strokeLinecap="round"
        />
        <path
          d="M160.099 75.4744V74.7554H159.747V75.4744H159.061V75.8222H159.747V76.5412H160.099V75.8222H160.799V75.4744H160.099Z"
          fill="#37363F"
        />
        <path
          d="M161.573 73.6698V74.0458H161.987V76.9595H162.391V73.6698H161.573Z"
          fill="#37363F"
        />
        <path
          d="M164.235 73.6228C163.511 73.6228 162.994 74.2102 162.994 75.3146C162.994 76.419 163.511 77.0065 164.235 77.0065C164.954 77.0065 165.471 76.419 165.471 75.3146C165.471 74.2102 164.954 73.6228 164.235 73.6228ZM164.235 74.0082C164.719 74.0082 165.039 74.4076 165.039 75.3146C165.039 76.2216 164.719 76.6211 164.235 76.6211C163.746 76.6211 163.427 76.2216 163.427 75.3146C163.427 74.4076 163.746 74.0082 164.235 74.0082Z"
          fill="#37363F"
        />
        <path
          d="M166.62 75.1172C167.047 75.1172 167.367 74.8024 167.367 74.37C167.367 73.9471 167.047 73.6228 166.62 73.6228C166.192 73.6228 165.872 73.9471 165.872 74.37C165.872 74.8024 166.192 75.1172 166.62 75.1172ZM166.62 76.9595L168.777 73.6698H168.391L166.23 76.9595H166.62ZM166.62 74.8118C166.38 74.8118 166.206 74.6238 166.206 74.37C166.206 74.1209 166.38 73.9377 166.62 73.9377C166.859 73.9377 167.043 74.1209 167.043 74.37C167.043 74.6238 166.859 74.8118 166.62 74.8118ZM168.382 77.0065C168.814 77.0065 169.134 76.6869 169.134 76.2592C169.134 75.8316 168.814 75.512 168.382 75.512C167.959 75.512 167.639 75.8316 167.639 76.2592C167.639 76.6869 167.959 77.0065 168.382 77.0065ZM168.382 76.6963C168.147 76.6963 167.968 76.513 167.968 76.2592C167.968 76.0102 168.147 75.8222 168.382 75.8222C168.626 75.8222 168.805 76.0102 168.805 76.2592C168.805 76.513 168.626 76.6963 168.382 76.6963Z"
          fill="#37363F"
        />
        <path
          d="M173.153 74.5439C172.857 74.5439 172.575 74.6755 172.434 74.9951C172.303 74.7131 172.039 74.5439 171.715 74.5439C171.457 74.5439 171.212 74.6567 171.062 74.9293V74.5862H170.658V76.9595H171.062V75.5167C171.062 75.1313 171.297 74.9058 171.621 74.9058C171.917 74.9058 172.119 75.1266 172.119 75.512V76.9595H172.523V75.5167C172.523 75.1313 172.754 74.9058 173.083 74.9058C173.374 74.9058 173.581 75.1266 173.581 75.512V76.9595H173.985V75.4415C173.985 74.9011 173.637 74.5439 173.153 74.5439Z"
          fill="#37363F"
        />
        <path
          d="M175.656 77.0065C176.342 77.0065 176.849 76.5036 176.849 75.7705C176.849 75.0421 176.342 74.5439 175.656 74.5439C174.974 74.5439 174.462 75.0421 174.462 75.7705C174.462 76.5036 174.974 77.0065 175.656 77.0065ZM175.656 76.6399C175.209 76.6399 174.875 76.3156 174.875 75.7705C174.875 75.2347 175.209 74.9105 175.656 74.9105C176.107 74.9105 176.44 75.2347 176.44 75.7705C176.44 76.3156 176.107 76.6399 175.656 76.6399Z"
          fill="#37363F"
        />
        <path
          d="M178.416 74.5439C178.124 74.5439 177.889 74.699 177.753 74.9951V74.5862H177.349V76.9595H177.753V75.6859C177.753 75.2535 177.993 74.9716 178.331 74.9716H178.557V74.5439H178.416Z"
          fill="#37363F"
        />
        <path
          d="M180.939 75.747C180.939 75.0233 180.478 74.5439 179.853 74.5439C179.195 74.5439 178.716 75.0233 178.716 75.7705C178.716 76.5083 179.195 77.0065 179.853 77.0065C180.295 77.0065 180.713 76.8091 180.93 76.2686L180.586 76.1276C180.436 76.5083 180.173 76.6446 179.858 76.6446C179.463 76.6446 179.162 76.3767 179.13 75.8598H180.934C180.939 75.8269 180.939 75.7893 180.939 75.747ZM179.849 74.8917C180.192 74.8917 180.455 75.1078 180.516 75.5496H179.144C179.209 75.1266 179.473 74.8917 179.849 74.8917Z"
          fill="#37363F"
        />
        <path
          d="M182.648 76.2592C182.648 76.6681 182.873 76.9595 183.329 76.9595H183.611V76.6023H183.367C183.146 76.6023 183.052 76.466 183.052 76.2263V74.9293H183.611V74.5862H183.052V73.8061L182.648 74.0693V74.5862H182.206V74.9293H182.648V76.2592Z"
          fill="#37363F"
        />
        <path
          d="M185.168 74.5439C184.886 74.5439 184.604 74.6661 184.444 74.9528V73.6698H184.04V76.9595H184.444V75.5496C184.444 75.1548 184.712 74.9058 185.083 74.9058C185.421 74.9058 185.652 75.1501 185.652 75.5355V76.9595H186.056V75.4744C186.056 74.9058 185.685 74.5439 185.168 74.5439Z"
          fill="#37363F"
        />
        <path
          d="M187.565 74.5439C187.095 74.5439 186.7 74.7789 186.583 75.2394L186.926 75.3663C187.001 75.0844 187.236 74.9058 187.56 74.9058C187.894 74.9058 188.19 75.0703 188.19 75.5167V75.8081C188.044 75.6389 187.8 75.5449 187.471 75.5449C186.95 75.5449 186.512 75.8081 186.512 76.2733C186.512 76.748 186.945 77.0065 187.457 77.0065C187.805 77.0065 188.054 76.9078 188.2 76.7245V76.9595H188.594V75.4744C188.594 74.8165 188.091 74.5439 187.565 74.5439ZM187.57 76.6869C187.208 76.6869 186.926 76.5506 186.926 76.2733C186.926 75.9961 187.208 75.8598 187.57 75.8598C187.927 75.8598 188.2 76.0055 188.2 76.2733C188.2 76.5412 187.927 76.6869 187.57 76.6869Z"
          fill="#37363F"
        />
        <path
          d="M190.308 74.5439C190.026 74.5439 189.744 74.6661 189.584 74.9528V74.5862H189.18V76.9595H189.584V75.5496C189.584 75.1548 189.852 74.9058 190.223 74.9058C190.561 74.9058 190.792 75.1501 190.792 75.5355V76.9595H191.196V75.4744C191.196 74.9058 190.825 74.5439 190.308 74.5439Z"
          fill="#37363F"
        />
        <path
          d="M193.523 76.6023C193.331 76.6023 193.255 76.4942 193.255 76.3015V73.6698H192.851V76.325C192.851 76.6963 193.058 76.9595 193.467 76.9595H193.721V76.6023H193.523Z"
          fill="#37363F"
        />
        <path
          d="M195.004 74.5439C194.534 74.5439 194.139 74.7789 194.022 75.2394L194.365 75.3663C194.44 75.0844 194.675 74.9058 194.999 74.9058C195.333 74.9058 195.629 75.0703 195.629 75.5167V75.8081C195.484 75.6389 195.239 75.5449 194.91 75.5449C194.389 75.5449 193.951 75.8081 193.951 76.2733C193.951 76.748 194.384 77.0065 194.896 77.0065C195.244 77.0065 195.493 76.9078 195.639 76.7245V76.9595H196.033V75.4744C196.033 74.8165 195.531 74.5439 195.004 74.5439ZM195.009 76.6869C194.647 76.6869 194.365 76.5506 194.365 76.2733C194.365 75.9961 194.647 75.8598 195.009 75.8598C195.366 75.8598 195.639 76.0055 195.639 76.2733C195.639 76.5412 195.366 76.6869 195.009 76.6869Z"
          fill="#37363F"
        />
        <path
          d="M197.493 77.0065C198.066 77.0065 198.442 76.7151 198.442 76.3156C198.442 75.9632 198.212 75.7517 197.714 75.6248L197.474 75.5637C197.192 75.4932 196.957 75.4086 196.957 75.1971C196.957 75.0186 197.154 74.8964 197.432 74.8964C197.732 74.8964 197.996 75.0233 198.061 75.3804L198.409 75.3005C198.339 74.793 197.916 74.5439 197.432 74.5439C196.905 74.5439 196.553 74.8165 196.553 75.2018C196.553 75.5402 196.764 75.7752 197.277 75.9068L197.516 75.9632C197.869 76.0525 198.038 76.137 198.038 76.325C198.038 76.5177 197.826 76.654 197.488 76.654C197.173 76.654 196.887 76.5083 196.802 76.1464L196.459 76.2451C196.6 76.795 197.009 77.0065 197.493 77.0065Z"
          fill="#37363F"
        />
        <path
          d="M199.091 76.2592C199.091 76.6681 199.316 76.9595 199.772 76.9595H200.054V76.6023H199.81C199.589 76.6023 199.495 76.466 199.495 76.2263V74.9293H200.054V74.5862H199.495V73.8061L199.091 74.0693V74.5862H198.649V74.9293H199.091V76.2592Z"
          fill="#37363F"
        />
        <path
          d="M202.767 74.5439C202.372 74.5439 202.1 74.7507 201.94 75.0421V74.5862H201.536V77.7349H201.94V76.5036C202.1 76.795 202.372 77.0018 202.767 77.0018C203.392 77.0018 203.867 76.5036 203.867 75.7705C203.867 75.0421 203.392 74.5439 202.767 74.5439ZM202.697 76.6352C202.25 76.6352 201.931 76.3156 201.931 75.7752C201.931 75.2347 202.25 74.9105 202.697 74.9105C203.143 74.9105 203.458 75.2347 203.458 75.7752C203.458 76.3156 203.143 76.6352 202.697 76.6352Z"
          fill="#37363F"
        />
        <path
          d="M206.48 75.747C206.48 75.0233 206.019 74.5439 205.394 74.5439C204.736 74.5439 204.257 75.0233 204.257 75.7705C204.257 76.5083 204.736 77.0065 205.394 77.0065C205.836 77.0065 206.254 76.8091 206.47 76.2686L206.127 76.1276C205.977 76.5083 205.714 76.6446 205.399 76.6446C205.004 76.6446 204.703 76.3767 204.671 75.8598H206.475C206.48 75.8269 206.48 75.7893 206.48 75.747ZM205.39 74.8917C205.733 74.8917 205.996 75.1078 206.057 75.5496H204.685C204.75 75.1266 205.014 74.8917 205.39 74.8917Z"
          fill="#37363F"
        />
        <path
          d="M208.05 74.5439C207.759 74.5439 207.524 74.699 207.387 74.9951V74.5862H206.983V76.9595H207.387V75.6859C207.387 75.2535 207.627 74.9716 207.966 74.9716H208.191V74.5439H208.05Z"
          fill="#37363F"
        />
        <path
          d="M208.798 74.1303C208.963 74.1303 209.09 74.0176 209.09 73.8484C209.09 73.6886 208.963 73.5711 208.798 73.5711C208.639 73.5711 208.517 73.6886 208.517 73.8484C208.517 74.0176 208.639 74.1303 208.798 74.1303ZM208.596 76.9595H209.001V74.5862H208.596V76.9595Z"
          fill="#37363F"
        />
        <path
          d="M210.698 77.0065C211.384 77.0065 211.892 76.5036 211.892 75.7705C211.892 75.0421 211.384 74.5439 210.698 74.5439C210.017 74.5439 209.505 75.0421 209.505 75.7705C209.505 76.5036 210.017 77.0065 210.698 77.0065ZM210.698 76.6399C210.252 76.6399 209.918 76.3156 209.918 75.7705C209.918 75.2347 210.252 74.9105 210.698 74.9105C211.149 74.9105 211.483 75.2347 211.483 75.7705C211.483 76.3156 211.149 76.6399 210.698 76.6399Z"
          fill="#37363F"
        />
        <path
          d="M214.206 75.0374C214.046 74.746 213.773 74.5439 213.379 74.5439C212.758 74.5439 212.279 75.0421 212.279 75.7705C212.279 76.5036 212.758 77.0018 213.379 77.0018C213.773 77.0018 214.046 76.7997 214.206 76.513V76.9595H214.61V73.6698H214.206V75.0374ZM213.454 76.6352C213.007 76.6352 212.688 76.3156 212.688 75.7705C212.688 75.23 213.007 74.9105 213.454 74.9105C213.9 74.9105 214.215 75.23 214.215 75.7705C214.215 76.3156 213.9 76.6352 213.454 76.6352Z"
          fill="#37363F"
        />
        <rect
          x={150.706}
          y={35.2941}
          width={72.9475}
          height={51.2118}
          rx={3.85176}
          stroke="#29292F"
          strokeWidth={0.350072}
          shapeRendering="crispEdges"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_2725_153142"
        x={56.439}
        y={69.1166}
        width={29.4893}
        height={21.5969}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.845951} />
        <feGaussianBlur stdDeviation={0.845951} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2725_153142"
        x={84.5054}
        y={69.1167}
        width={20.8594}
        height={11.6477}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.845951} />
        <feGaussianBlur stdDeviation={0.845951} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_2725_153142"
        x={84.5054}
        y={79.2263}
        width={20.8594}
        height={11.6477}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.845951} />
        <feGaussianBlur stdDeviation={0.845951} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_2725_153142"
        x={111.996}
        y={69.1166}
        width={29.4893}
        height={21.5969}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.845951} />
        <feGaussianBlur stdDeviation={0.845951} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_2725_153142"
        x={140.063}
        y={69.1167}
        width={20.8594}
        height={11.6477}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.845951} />
        <feGaussianBlur stdDeviation={0.845951} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_2725_153142"
        x={140.063}
        y={79.2263}
        width={20.8594}
        height={11.6477}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.845951} />
        <feGaussianBlur stdDeviation={0.845951} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_d_2725_153142"
        x={167.552}
        y={69.1166}
        width={29.4893}
        height={21.5969}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.845951} />
        <feGaussianBlur stdDeviation={0.845951} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_d_2725_153142"
        x={56.3774}
        y={102.999}
        width={46.1241}
        height={29.2743}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.876717} />
        <feGaussianBlur stdDeviation={0.876717} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter8_d_2725_153142"
        x={109.059}
        y={102.999}
        width={39.6739}
        height={29.2743}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.876717} />
        <feGaussianBlur stdDeviation={0.876717} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter9_d_2725_153142"
        x={155.291}
        y={102.999}
        width={42.1651}
        height={28.8485}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.876717} />
        <feGaussianBlur stdDeviation={0.876717} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter10_d_2725_153142"
        x={53.6309}
        y={75.2571}
        width={87.8417}
        height={57.5654}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2.56784} />
        <feGaussianBlur stdDeviation={2.56784} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter11_d_2725_153142"
        x={12.337}
        y={11.7278}
        width={87.1073}
        height={61.8333}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2.56784} />
        <feGaussianBlur stdDeviation={2.56784} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <filter
        id="filter12_d_2725_153142"
        x={145.396}
        y={32.5512}
        width={83.5692}
        height={61.8333}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity={0}
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2.56784} />
        <feGaussianBlur stdDeviation={2.56784} />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.560784 0 0 0 0 0.584314 0 0 0 0 0.698039 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2725_153142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2725_153142"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_2725_153142">
        <rect
          width={246}
          height={138}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_2725_153142">
        <rect
          x={47.6475}
          y={23.295}
          width={158.232}
          height={142.829}
          rx={3.3654}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip2_2725_153142">
        <rect
          width={2.18236}
          height={2.18236}
          fill="white"
          transform="translate(164.239 54.0812)"
        />
      </clipPath>
      <clipPath id="clip3_2725_153142">
        <rect
          width={2.18236}
          height={2.18236}
          fill="white"
          transform="translate(179.967 54.0812)"
        />
      </clipPath>
      <clipPath id="clip4_2725_153142">
        <rect
          width={2.18236}
          height={2.18236}
          fill="white"
          transform="translate(194.896 54.0812)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgLearnMoreDemoOps = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgLearnMoreDemoOps;
